function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.469727 13.2969C0.170898 13.5957 0.162109 14.1055 0.469727 14.4043C0.777344 14.7031 1.28711 14.7031 1.58594 14.4043L7.21094 8.7793L12.8359 14.4043C13.1348 14.7031 13.6533 14.7119 13.9521 14.4043C14.251 14.0967 14.251 13.5957 13.9521 13.2969L8.32715 7.66309L13.9521 2.03809C14.251 1.73926 14.2598 1.22949 13.9521 0.930664C13.6445 0.623047 13.1348 0.623047 12.8359 0.930664L7.21094 6.55566L1.58594 0.930664C1.28711 0.623047 0.768555 0.614258 0.469727 0.930664C0.170898 1.23828 0.170898 1.73926 0.469727 2.03809L6.09473 7.66309L0.469727 13.2969Z",
  fill: "#64AD57"
});

var SvgClose = function SvgClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close.5312119b.svg";
export { ForwardRef as ReactComponent };